export default function Logo({ light = false, className = "", testid }) {
  const bg = light ? "#FFFFFF" : "#F0F9FF";
  const frontF = "var(--reference-blue)";
  const backF = "var(--reference-blue-hover)";
  return (
    <span className={`inline-flex items-center gap-3 ${className}`} aria-label="Ferry Freight LLC" data-testid={testid}>
      <svg viewBox="0 0 48 48" className="h-10 w-10 shrink-0" aria-hidden="true" data-testid={testid ? `${testid}-mark` : undefined}>
        <rect width="48" height="48" rx="12" fill={bg} />
        <path d="M21 16 H37 V21 H26 V25.5 H33 V30.5 H26 V40 H21 Z" fill={backF} />
        <path d="M11 12 H27 V17 H16 V21.5 H23 V26.5 H16 V36 H11 Z" fill={frontF} />
      </svg>
      <span className="font-display leading-none">
        <span className={`block text-[17px] font-bold ${light ? "text-white" : "text-ink"}`} data-testid={testid ? `${testid}-wordmark` : undefined}>
          Ferry Freight <span className="text-inherit" data-testid={testid ? `${testid}-llc` : undefined}>LLC</span>
        </span>
      </span>
    </span>
  );
}
